var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Статусы проекта",
      "create-text": "Новый",
      "fetch-data": _vm.fetchData,
      "route-create": "ProjectStatusAdd",
      "route-edit": "ProjectStatusEdit",
      "route-view": "ProjectStatusView",
      "route-path": "/project_statuses",
      "can-edit": _vm.canEditProjectStatusCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8755d604", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8755d604","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/ProjectStatuses/ProjectStatuses.vue
// module id = null
// module chunks = 